import React, { useState } from 'react';
import { ReportBuildMetadataFilters } from '@tera/shared/src/types/ReportBuildMetadata';
import { ReportFiltroAtivo } from '../../pages/relatorios/util';
import FiltroRelatorioCampo, { getDefaultOperator } from './FiltroRelatorioCampo';
import CampoSeletor from '../Formulario/CampoSeletor';
import Botao from '../Botao';
import HBox from '../layout/HBox';
import VBox from '../layout/VBox';
import { mdiClose, mdiPlus } from '@mdi/js';
import styles from './FiltroConstrutor.module.css';

type Props = {
    filtersMetadata: ReportBuildMetadataFilters;
    reportHref: string;
    value: ReportFiltroAtivo[];
    onChange: (v: ReportFiltroAtivo[]) => void;
};

const FiltroConstrutor = ({ filtersMetadata, reportHref, value, onChange }: Props) => {
    const [addingField, setAddingField] = useState(false);

    const usedFields = value.map(f => f.field);
    const availableFields = Object.values(filtersMetadata).filter(
        f => !usedFields.includes(f.name)
    );

    const handleAddField = (fieldName: string | null) => {
        if (!fieldName) return;
        const field = filtersMetadata[fieldName];
        if (!field) return;
        const defaultOp = getDefaultOperator(field.type, field.options, field.lookup);
        onChange([
            ...value,
            { field: fieldName, type: field.type, operator: defaultOp, value: null },
        ]);
        setAddingField(false);
    };

    const handleRemove = (idx: number) => {
        onChange(value.filter((_, i) => i !== idx));
    };

    const handleFilterChange = (idx: number, newFiltro: ReportFiltroAtivo) => {
        const newFiltros = [...value];
        newFiltros[idx] = newFiltro;
        onChange(newFiltros);
    };

    return (
        <VBox gap="8px">
            {value.length === 0 && !addingField && (
                <span style={{ color: 'var(--tc-color-secondary, #6b7280)', fontSize: '0.875rem' }}>
                    Nenhum filtro configurado.
                </span>
            )}

            {value.map((filtro, idx) => (
                <HBox key={`${filtro.field}-${idx}`} className={styles.filtroRow} style={{ gap: 4, alignItems: 'flex-start' }}>
                    {filtersMetadata[filtro.field] && (
                        <div style={{ flex: 1 }}>
                            <FiltroRelatorioCampo
                                fieldMeta={filtersMetadata[filtro.field]}
                                reportHref={reportHref}
                                value={filtro}
                                onChange={newFiltro => handleFilterChange(idx, newFiltro)}
                            />
                        </div>
                    )}
                    <div>
                        <div style={{ lineHeight: '1.5', fontSize: '1.25rem' }}>&nbsp;</div>
                        <Botao
                            variant="outline-danger"
                            onClick={() => handleRemove(idx)}
                            icon={mdiClose}
                            title="Remover filtro"
                        />
                    </div>
                </HBox>
            ))
            }

            {
                availableFields.length > 0 && (
                    <div className={styles.addArea}>
                        {addingField ? (
                            <HBox style={{ gap: 8, alignItems: 'center' }}>
                                <div style={{ flex: 1 }}>
                                    <CampoSeletor
                                        options={availableFields.map(f => ({ id: f.name, label: f.label }))}
                                        value={null}
                                        onChange={handleAddField}
                                        placeholder="Selecionar campo de filtro…"
                                        nullable
                                    />
                                </div>
                                <Botao variant="outline-secondary" onClick={() => setAddingField(false)}>
                                    Cancelar
                                </Botao>
                            </HBox>
                        ) : (
                            <Botao variant="outline-primary" icon={mdiPlus} onClick={() => setAddingField(true)}>
                                Adicionar filtro
                            </Botao>
                        )}
                    </div>
                )
            }
        </VBox >
    );
};

export default FiltroConstrutor;
